module.exports = __webpack_public_path__ + "static/media/MTL.646646dd.ipynb";